// The API serializes DateTime as "2025-01-17 12:59:36.000Z" — a space where
// ISO 8601 wants a "T". Parsing a non-ISO string is implementation-defined:
// WebKit up to iOS 15 reads it as an Invalid Date, and `Intl.DateTimeFormat`
// then throws on it (SHORTS-WEB-FT). Replaced rather than round-tripped
// through `Date`, so the value also serves where a string is wanted as is
// (schema.org dates).
export const toIsoDate = (value: string): string => value.replace(" ", "T");
